(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lvdg-campaign-clock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('samael-campaign-clock')) {
    class SamaelCampaignClock extends HTMLElement {
      constructor() {
        super();
        this.refresh = this.refresh.bind(this);
      }
      connectedCallback() {
        this.refresh();
        window.addEventListener('pageshow', this.refresh);
        document.addEventListener('visibilitychange', this.refresh);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('pageshow', this.refresh);
        document.removeEventListener('visibilitychange', this.refresh);
      }
      refresh() {
        clearTimeout(this.timer);
        const bounds = [this.dataset.openAt, this.dataset.dispatchAt, this.dataset.afterAt].map(Number);
        if (!bounds.every(Number.isFinite) || !(bounds[0] < bounds[1] && bounds[1] < bounds[2])) return;
        const now = Date.now();
        const phase = now < bounds[0] ? 'opening' : now < bounds[1] ? 'preparing' : now < bounds[2] ? 'dispatch' : 'followup';
        this.dataset.phase = phase;
        this.querySelectorAll('[data-campaign-phases]').forEach(node => {
          node.hidden = !node.dataset.campaignPhases.split(' ').includes(phase);
        });
        this.querySelectorAll('[data-campaign-step]').forEach(node => {
          const current = node.dataset.campaignStep === phase;
          node.classList.toggle('is-current', current);
          if (current) node.setAttribute('aria-current', 'step');
          else node.removeAttribute('aria-current');
        });
        const next = bounds.find(value => value > now);
        if (next && this.isConnected) {
          this.timer = setTimeout(this.refresh, Math.max(25, Math.min(60000, next - now + 25)));
        }
      }
    }
    customElements.define('samael-campaign-clock', SamaelCampaignClock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lvdg-seal-portal"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (!location.pathname.replace(/\/+$/, '').endsWith('/a/subscriptions/manage')) return;
  const copyElement = document.getElementById('lvdg-seal-copy');
  if (!copyElement) return;
  let copy;
  try { copy = JSON.parse(copyElement.textContent); } catch (_) { return; }
  const main = document.getElementById('MainContent');
  if (!main) return;
  const panelUrl = '/pages/mon-abonnement';
  const calendarUrl = '/pages/calendrier-prelevements-abonnement';
  const accountUrl = 'https://account.lesvapeursdugrimoire.com/orders';
  function make(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }
  function link(text, href, className) {
    const element = make('a', className, text);
    element.href = href;
    return element;
  }
  function statusFor(text) {
    const match = text.match(/(?:statut|status)\s*:\s*(suspendu|suspended|paused|en pause|actif|active|annul[ée]|cancelled|canceled|expired|expir[ée]|arr[êe]t[ée])/i);
    if (!match) return 'unknown';
    const value = match[1].toLowerCase();
    if (/suspend|paused|en pause/.test(value)) return 'paused';
    if (/actif|active/.test(value)) return 'active';
    return 'cancelled';
  }
  function contractLinks(root) {
    return Array.from(root.querySelectorAll('a[href]')).filter(function (a) {
      if (!/^#\s*\d+$/.test(a.textContent.trim())) return false;
      try {
        const url = new URL(a.getAttribute('href'), location.href);
        return url.origin === location.origin && url.pathname.indexOf('/a/subscriptions') !== -1;
      } catch (_) { return false; }
    });
  }
  function findCard(anchor, root) {
    let candidate = anchor.parentElement;
    while (candidate && candidate !== root) {
      const text = candidate.innerText;
      if (text && /(?:statut|status)\s*:/i.test(text) && contractLinks(candidate).length === 1) return candidate;
      candidate = candidate.parentElement;
    }
    return null;
  }
  function addHeading(root) {
    const nativeHeading = root.querySelector('h1');
    if (nativeHeading) {
      nativeHeading.classList.add('lvdg-seal-native-title');
      const nativeGroup = nativeHeading.closest('.seal-layout');
      if (nativeGroup && nativeGroup.textContent.trim() === nativeHeading.textContent.trim()) nativeGroup.hidden = true;
    }
    const header = make('header', 'lvdg-seal-header');
    const nav = make('nav', 'lvdg-seal-nav');
    nav.setAttribute('aria-label', copy.back);
    nav.append(link('← ' + copy.back, panelUrl), link(copy.calendar, calendarUrl));
    header.append(nav, make('p', 'lvdg-seal-kicker', copy.kicker), make('h1', '', copy.heading), make('p', 'lvdg-seal-intro', copy.intro));
    root.prepend(header);
    const help = make('section', 'lvdg-seal-help');
    const title = make('h2', '', copy.help);
    title.id = 'lvdg-seal-help-title';
    help.setAttribute('aria-labelledby', title.id);
    help.append(title);
    [['faqDate', 'faqDateBody'], ['faqAction', 'faqActionBody'], ['faqPause', 'faqPauseBody']].forEach(function (keys) {
      const detail = make('details');
      detail.append(make('summary', '', copy[keys[0]]), make('p', '', copy[keys[1]]));
      help.append(detail);
    });
    help.append(link(copy.contact, '/pages/contact', 'lvdg-seal-contact'));
    root.append(help);
  }
  function enhanceSignedOut(root) {
    const native = root.querySelector('.seal-not-logged-in');
    if (!native || root.querySelector('.lvdg-seal-signin')) return;
    const section = make('section', 'lvdg-seal-signin');
    section.append(make('h2', '', copy.signedOut), make('p', '', copy.signedOutBody), link(copy.signIn, accountUrl, 'lvdg-seal-primary'));
    native.insertAdjacentElement('afterend', section);
    native.hidden = true;
  }
  function enhanceCard(anchor, root) {
    const card = findCard(anchor, root);
    if (!card || card.dataset.lvdgSealCard) return false;
    const text = card.innerText;
    const status = statusFor(text);
    card.dataset.lvdgSealCard = 'true';
    card.dataset.lvdgSealStatus = status;
    card.dataset.lvdgSealSearch = text.toLocaleLowerCase();
    card.classList.add('lvdg-seal-card');
    anchor.classList.add('lvdg-seal-number');
    anchor.setAttribute('aria-label', copy.identifier + ' ' + anchor.textContent.trim());
    if (status === 'paused') card.classList.add('lvdg-seal-card--paused');
    const actions = make('div', 'lvdg-seal-card-actions');
    const button = link(copy.open, anchor.getAttribute('href'), 'lvdg-seal-primary');
    button.setAttribute('aria-label', copy.open + ' ' + anchor.textContent.trim());
    actions.append(button);
    const explanation = make('details', 'lvdg-seal-status-help');
    explanation.append(make('summary', '', status === 'paused' ? copy.pausedTitle + ' — ' + copy.statusHelp.toLocaleLowerCase() : copy.statusHelp), make('p', '', copy[status]));
    actions.append(explanation);
    card.append(actions);
    return true;
  }
  function updateControls(root) {
    const cards = Array.from(root.querySelectorAll('[data-lvdg-seal-card]'));
    let toolbar = root.querySelector('.lvdg-seal-toolbar');
    if (cards.length < 2) {
      if (toolbar) toolbar.remove();
      cards.forEach(function (card) { card.hidden = false; });
      return;
    }
    if (toolbar) return;
    toolbar = make('section', 'lvdg-seal-toolbar');
    const searchLabel = make('label', '', copy.search);
    const search = make('input');
    search.type = 'search';
    search.placeholder = copy.searchHint;
    searchLabel.append(search);
    const filterLabel = make('label', '', copy.filter);
    const select = make('select');
    [['all', 'all'], ['active', 'activeFilter'], ['paused', 'pausedFilter'], ['cancelled', 'stoppedFilter']].forEach(function (entry) {
      const option = make('option', '', copy[entry[1]]);
      option.value = entry[0];
      select.append(option);
    });
    filterLabel.append(select);
    const count = make('p', 'lvdg-seal-count');
    count.setAttribute('role', 'status');
    count.setAttribute('aria-live', 'polite');
    toolbar.append(searchLabel, filterLabel, count);
    root.querySelector('.lvdg-seal-header').insertAdjacentElement('afterend', toolbar);
    function filterCards() {
      let visible = 0;
      const term = search.value.trim().toLocaleLowerCase();
      root.querySelectorAll('[data-lvdg-seal-card]').forEach(function (card) {
        const matches = (!term || card.dataset.lvdgSealSearch.indexOf(term) !== -1) && (select.value === 'all' || card.dataset.lvdgSealStatus === select.value);
        card.hidden = !matches;
        if (matches) visible++;
      });
      const message = visible ? visible + ' ' + copy.count : copy.empty;
      if (count.textContent !== message) count.textContent = message;
    }
    search.addEventListener('input', filterCards);
    select.addEventListener('change', filterCards);
    filterCards();
  }
  function enhance() {
    const root = main.querySelector('.seal-subscription-page');
    if (!root) return;
    if (!root.dataset.lvdgSealUx) {
      root.dataset.lvdgSealUx = 'true';
      addHeading(root);
    }
    enhanceSignedOut(root);
    let changed = false;
    contractLinks(root).forEach(function (anchor) { changed = enhanceCard(anchor, root) || changed; });
    if (changed) updateControls(root);
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; enhance(); });
  }
  const observer = new MutationObserver(schedule);
  observer.observe(main, {childList:true, subtree:true, characterData:true});
  document.addEventListener('sealsubs_portal:loaded', schedule);
  enhance();
})();
  } catch(e) { console.error(e); }
})();

})();
